"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _headerTranslations = _interopRequireDefault(require("../header-translations"));
var _Search = _interopRequireDefault(require("./Search"));
var _MobileSearch = _interopRequireDefault(require("./MobileSearch"));
var _Grip = _interopRequireDefault(require("./Grip"));
var _Drawer = _interopRequireDefault(require("./Drawer"));
var _Link = _interopRequireDefault(require("../Link"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SiteSelector = _interopRequireDefault(require("./SiteSelector"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

const ANIMTIME = 0.3;
/**
 * Class container of entire Header.
 */
class Header extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      searchOpen: false,
      hidden: false,
      scrollStart: 0,
      buttonWidth: 0,
      minWidth: 0,
      scrollPosition: 0,
      overflowAnim: true,
      left: 0,
      isMobile: false,
      // use base tranlastions and override with Drupal Menu API
      translations: this.props.drupalData || _headerTranslations.default[this.props.lang]
    };
    this.minWdith = 0;
    this.globalClose = this.handleClose.bind(this);
    this.throttleResize = this.resize.bind(this);
    this.handleEscKey = this.handleEscEvent.bind(this);
    this.toggleMenuEvent = this.toggleMenu.bind(this);
    this.handleScrolling = this.handleScroll.bind(this);
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScrolling);

    // Add varible to track that it's mobile
    this.setState({
      isMobile: window.innerWidth < 1200
    });
    window.addEventListener('resize', this.throttleResize);
  }

  // Remember to remove the listener if they move off this component
  componentWillUnmount() {
    // Remove the event with 'this' bound
    window.removeEventListener('scroll', this.handleScrolling);
    window.removeEventListener('resize', this.throttleResize);
    window.removeEventListener('keydown', this.handleEscKey);
  }
  useHtml(html) {
    return {
      __html: html
    };
  }

  // 27 is the escape keyCode
  handleEscEvent(e) {
    if (e.keyCode === 27) {
      this.toggleMenu();
    }
  }

  // This prevents unnecessary rendering on resize
  resize() {
    clearTimeout(this.resizeReady);
    this.resizeReady = setTimeout(() => {
      this.setState({
        isMobile: window.innerWidth < 1200
      });
      if (!this.props.isMobile) {
        this.setState({
          open: false
        });
      }
    }, 50);
  }

  // Pass to the Drawer Component to prevent
  // the click inside the menu from closing it
  handleBubble(e) {
    e.stopPropagation();
  }

  // Is added as a window.onClick event to handle closing the menu
  // once it has been opened
  handleClose(e) {
    this.toggleMenu();
  }

  // Handle scroll position.
  scrollMove(e) {
    this.setState({
      scrollTime: setTimeout(function () {
        const delta = this.state.scrollPosition - this.state.scrollStart;
        const update = {
          scrollPosition: 0,
          scrollStart: 0
        };
        if (delta > 50) {
          update.hidden = true;
          update.overflowAnim = false;
        } else if (delta < -20) {
          update.hidden = false;
          setTimeout(function () {
            this.setState({
              overflowAnim: true
            });
          }.bind(this), ANIMTIME * 1000);
        }
        this.setState(update);
      }.bind(this), 200)
    });
  }
  handleScroll(e) {
    if (this.state.open) {
      return;
    }
    if (this.state.scrollPosition === 0) {
      this.scrollMove();
      this.setState({
        scrollPosition: window.scrollY,
        scrollStart: window.scrollY
      });
    } else {
      this.setState({
        scrollPosition: window.scrollY
      });
    }
  }
  toggleMenu() {
    this.setState({
      open: !this.state.open
    });
  }
  toggleSearch() {
    this.setState({
      searchOpen: !this.state.searchOpen
    });
  }
  getClassStyle(classes, secondToLast) {
    if (!classes) {
      return secondToLast ? '#f0ab00' : '#008FD3';
    }
    const colorList = [{
      class: 'gold',
      color: '#fff'
    }, {
      class: 'concur-blue',
      color: '#008FD3'
    }, {
      class: 'white',
      color: '#fff'
    }];
    return colorList.find(function (color) {
      return classes.match(color.class);
    }).color;
  }
  /**
   * Renders butons in php
   */
  renderButtons() {
    return this.state.translations.mainBtn.map(function (btn, key) {
      const secondToLast = key === this.state.translations.mainBtn.length - 2;
      const color = this.getClassStyle(btn.classes, secondToLast);
      // const excludeCE = btn.text === this.state.translations.loginLink.text ? ' -ce-ignore' : '';
      if (!btn.link) {
        return /*#__PURE__*/_react.default.createElement("span", {
          key: key,
          style: {
            margin: '15px 5px',
            float: 'left',
            textDecoration: 'none'
          },
          className: btn.classes || 'hidden-xs'
        }, btn.text);
      }
      return /*#__PURE__*/_react.default.createElement(_Link.default, {
        key: key,
        href: btn.link
        // rel={btn.text === this.state.translations.loginLink.text ? 'nofollow' : ''}
        ,
        style: {
          float: 'left',
          padding: '12px 16px',
          fontSize: '14px',
          lineHeight: '15px',
          borderColor: color,
          color: color,
          borderWidth: '1px',
          borderStyle: 'solid',
          borderRadius: '1px',
          fontWeight: '300',
          textDecoration: 'none',
          transition: 'all 0.25s ease-in-out'
        },
        hoverStyles: {
          backgroundColor: color,
          borderColor: color,
          color: color === '#fff' ? '#000' : '#fff'
        }
        // className={btn.classes + excludeCE || ('btn-ghost hidden-xs' + excludeCE + (secondToLast ? ' gold' : ' concur-blue'))}
        ,
        className: btn.classes || 'btn-ghost hidden-xs' + (secondToLast ? ' gold' : ' concur-blue')
      }, btn.text);
    }.bind(this));
  }

  /**
   * Calculate the height of the page.
   */
  getPageHeight() {
    if (typeof document === 'undefined') return 0;
    const body = document.body;
    const html = document.documentElement;
    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight) - 75;
  }
  render() {
    const stickyMenuStyles = {
      width: '100%',
      position: 'fixed',
      backgroundColor: '#000',
      color: '#fff',
      // transition: `all ${ANIMTIME}s ease-in-out`,
      zIndex: 3
    };
    const drawerContainer = {
      position: 'absolute',
      right: 0,
      left: 0
    };
    drawerContainer.height = this.state.isMobile && this.state.open ? '100%' : 'auto';
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "www-header-com",
      style: {
        height: '75px'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: "consent_blackbar"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "sticky-menu",
      style: stickyMenuStyles
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "container",
      style: {
        paddingRight: '14px',
        paddingLeft: '14px'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-12",
      onClick: this.state.open ? this.handleBubble : false
    }, /*#__PURE__*/_react.default.createElement("a", {
      style: {
        position: 'relative',
        zIndex: '40',
        lineHeight: '54px'
      },
      className: "pull-left",
      title: "SAP Concur",
      href: this.state.translations.logo.href || '/'
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        background: 'url(sites/all/modules/custom_concur/concur_responsive_menu/images/sap-concur.svg) no-repeat',
        width: '165px',
        height: '36px',
        position: 'relative',
        top: '20px',
        marginTop: '0',
        marginRight: '20px'
      }
    })), /*#__PURE__*/_react.default.createElement(_Drawer.default, {
      open: this.state.open,
      siteLinks: this.state.translations.siteLinks,
      supportLinks: this.state.translations.supportLinks,
      mobileAppText: this.state.translations.mobileAppText,
      socialLinks: this.state.translations.socialLinks,
      handleBubble: this.handleBubble,
      isMobile: this.state.isMobile
      // loginLink={this.state.translations.loginLink}
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-lg-4 col-md-6 col-sm-8 pull-right flush-right cta-wrap",
      style: {
        height: '75px',
        padding: 0,
        width: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_Grip.default, {
      toggleMenu: this.toggleMenuEvent,
      open: this.state.open,
      dropdownLabel: this.state.translations.menuToggle && this.state.translations.menuToggle.label
    }), /*#__PURE__*/_react.default.createElement(_SiteSelector.default, {
      lang: this.props.lang,
      isMobile: this.state.isMobile
    }), /*#__PURE__*/_react.default.createElement(_Search.default, {
      hasSearch: !!this.state.translations.search,
      placeholder: this.state.translations.search && this.state.translations.search.placeholder,
      searchOpen: this.state.searchOpen,
      open: this.state.open,
      toggleSearch: this.toggleSearch.bind(this),
      isMobile: this.state.isMobile,
      minWidth: this.state.minWidth
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "pull-right cta-button-container hidden-xs",
      style: {
        display: 'inline',
        position: 'relative',
        top: '18px',
        paddingRight: '4px',
        left: '-2px'
      }
    }, this.renderButtons()))), /*#__PURE__*/_react.default.createElement(_MobileSearch.default, {
      hasSearch: !!this.state.translations.search,
      placeholder: this.state.translations.search && this.state.translations.search.placeholder,
      searchOpen: this.state.searchOpen,
      isMobile: this.state.isMobile,
      open: this.state.open
    }))));
  }
}
exports.default = Header;
;
Header.propTypes = {
  lang: _propTypes.default.string,
  open: _propTypes.default.bool,
  drupalData: _propTypes.default.object,
  isMobile: _propTypes.default.bool
};
Header.defaultProps = {
  lang: 'en-us',
  open: false
};